import Dashboard from "../views/agent-dashboard";
import Agent from "../views/agent-management";
import Rates from "../views/Rates-Management";
import AgentInvoice from "../views/agent-invoice";
import Invoice from "../views/list-agent-invoice";
import FCMMessages from '../views/FCMmessages/FcmMessages'
import PromotionalMessages from "../views/PromotionalMessages/PromotionalMessages";
import CreateRatesForm from "../views/Rates-Management/CreateRatesForm";
import UpdateRates from "../views/Rates-Management/updateRatesForm";
import Logs from "../views/LogsOnPannel/Logs";
// contain list of routes
const routes = [
  {
    path: "/dashboard",
    component: Dashboard,
    exact: true
  },

 
  {
    path: "/dashboard/agent",
    component: Agent,
    exact: false
  },
  {
    path: "/dashboard/Rates",
    component: Rates,
    exact: false
  },
  {
    path: "/dashboard/agentinvoice",
    component: AgentInvoice,
    exact: false
  },
  {
    path: "/dashboard/listagentinvoice",
    component: Invoice,
    exact: true
  },
  {
    path: "/dashboard/PromotionalMessages",
    component: PromotionalMessages,
    exact: false
  },
  {
    path: "/dashboard/FCMMessages",
    component: FCMMessages,
    exact: false
  },
  {
    path: "/dashboard/createRates",
    component: CreateRatesForm,
    exact: false
  },
  {
    path: "/dashboard/updateRates",
    component: UpdateRates,
    exact: false
  },
  {
    path: "/dashboard/logs",
    component: Logs,
    exact: false
  }

];

export default routes;
